import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./userSlice";
import paymentReducer from "./paymentSlice";

export const store = configureStore({
  reducer: {
    user: userSlice,
    payment: paymentReducer,
  },
});